import { FloatingWhatsAppButton } from "@components/buttons/whatsapp";
import AppRoutes from "routes";

export function AppContent() {

  return (
    <>
      <AppRoutes />
      <FloatingWhatsAppButton />
    </>
  );
}
